import { TaxRateAttributes } from '@/types'
import { UpdateTaxRateMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditTaxRateQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { useEffect, useState } from 'react'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { Button } from '../base/button'

type TaxRate = EditTaxRateQuery['taxRates']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<UpdateTaxRateMutation, TaxRateAttributes, EditTaxRateQuery, TaxRate>({
    id,
    initializer: v => ({
      name: v.name,
      rate: v.rate
    }),
    query: EditQuery,
    queryKey: 'taxRates',
    mutation: UpdateMutation,
    resultKey: 'updateTaxRate'
  })
  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
          { formBuilder.buildField({ name: 'Rate', field: 'rate', type: 'percentage' }) }
        </div>
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
      </div>
      <DeleteDialog
        id={id}
        mutation={DeleteMutation}
        open={showDelete}
        refetchQueries={[TableQuery]}
        setOpen={setShowDelete}
        onSuccess={onDelete}
      />
    </>
  )
}
